import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SidebarCommon} from '../../../@core/common/sidebar';
import {ApiService} from '../../../@core/service/api.service';
import {EOfferType, ErpRoles, UserModel} from '../../../@models';
import {Observable} from 'rxjs';
import {NbToastrService} from '@nebular/theme';
import {FormListCheckboxRendererComponent} from '../../shared/form-list/renderer/form-list-checkbox-renderer.component';
import {FormListBusinessRendererComponent} from '../../shared/form-list/renderer/form-list-business-renderer.component';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { mongoId } from '../../../@core/common/global';
import { PagesComponent } from '../../pages.component';

@Component({
    selector: 'ngx-administration',
    templateUrl: './administration-user.component.html',
    styleUrls: ['./administration-user.component.scss']
})
export class AdministrationUserComponent extends SidebarCommon<UserModel> implements OnInit, OnDestroy {

  // users: Observable<UserModel[]>;
  selected: UserModel;

  // selectedContactName: string;
  // contactService: CompleterData;

  combinedContactOptions: { id: string, name: string }[] = [];

  changePassword = false;

  public roleColumns = {
    region: {
      title: 'Region',
      type: 'custom',
      renderComponent: FormListBusinessRendererComponent,
      editor: {
        type: 'list',
        config: {
          list: [],
        },
      },
      filter: false,
    },
    read: {
      title: 'Read',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',
      },
      filter: false,
    },
    write: {
      title: 'Write',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',
      },
      filter: false,
    },
    admin: {
      title: 'Admin',
      type: 'custom',
      renderComponent: FormListCheckboxRendererComponent,
      editor: {
        type: 'checkbox',
      },
      filter: false,
    },
  };
  ////////////////////////////////////////////////////////////////////////////

  p: number = 1;

  ////////////////////////////////////////////////////////////////////////////

  constructor(
    public auth: AuthGuardService,
    public api: ApiService,
    public data: SharedDataService,
    private toastrService: NbToastrService,
    private cdRef: ChangeDetectorRef,
    // private completerService: CompleterService,
  ) {
    super();
    // this.users = api.users;
    // this.contactService = this.completerService.local(
    //   this.api.reloadContacts(), 'displayTitle', 'displayTitle')
  }

  async ngOnInit(): Promise<void> {
    await this.data.loadUsers();
    this.api.reloadRegions().subscribe((regions) => {
      this.roleColumns.region.editor.config.list = regions.map(x => {
        return {
          title: x.name,
          value: x._id,
        }
      })
    })
    this.data.loadContacts().then(async contacts => {
      await this.data.loadBusinesses();
      this.combinedContactOptions = contacts.filter(f => +f.type === 5).sort((a, b) => a.title.localeCompare(b.title)).map(m => {
        const businessName = this.data.businesses.filter(f => f.active && f.name).find(f => mongoId(f) === mongoId(m.business))?.name;
        const _position = m.fields.find(f => +f.type === 2)?.value;
        const position = _position && ` ( ${_position} )` || '';
        return ({ id: businessName && m._id, name: `${businessName} | ${m.title} ${position}`})
      }).filter(f => f.id).sort((a,b) => a.name.localeCompare(b.name))
    });

  }

  ngOnDestroy(): void {
  }

  ////////////////////////////////////////////////////////////////////////////

  validate(event) {
    if (event.newData.region === '') {
      event.confirm.reject('Region is required');
      this.toastrService.danger('Region is required', 'Error');
    } else event.confirm.resolve();
  }

  ////////////////////////////////////////////////////////////////////////////

  create() {
    super.create();
    this.selected.active = true;
    // this.selectedContactName = '';
    this.selected.erpRoles = new ErpRoles();
    this.changePassword = true
  }

  cancel(item: UserModel) {
    this.hideSidebar();
  }

  save(item: UserModel) {
    this.hideSidebar();
    item.roles = item.roles.map(x => ({
      admin: x.admin || false,
      read: x.read || false,
      write: x.write || false,
      business: x.business,
      region: x.region,
    }));
    this.api.saveUser(item)
      .subscribe(async (i) => {
        this.toastrService.success(`User '${i.name}' saved!`, 'Success');
        await this.data.reloadUsers();
        PagesComponent.updateMenu(await this.auth.loadMe());
      });
  }


  // selectContact(item: CompleterItem): void {
  //   if (item != null)
  //     this.selected.contact = item.originalObject._id;
  //   else {
  //     this.selected.contact = null;
  //   }
  // }

  public toggleSidebar(item: UserModel) {
    super.toggleSidebar(item);
    this.changePassword = false;
    // if (item != null && item.contact != null) {
    //   this.selectedContactName = `${item.contact.business && item.contact.business.name}: ${item.contact.title}`
    // }
    if (item != null && item.erpRoles == null) {
      item.erpRoles = new ErpRoles();
    }
    if (!item.erpRoles.offers) item.erpRoles.offers = EOfferType.none;
    if (item.erpRoles.admin) {
      this.onErpAdminChange(true);
    }
  }

  onErpAdminChange(admin: boolean) {
    if (admin && this.selected.erpRoles) {
      this.selected.erpRoles.nrka = this.selected.erpRoles.nrkg = this.selected.erpRoles.products
        = this.selected.erpRoles.reports = this.selected.erpRoles.customerReport = this.selected.erpRoles.materials = true;
      this.selected.erpRoles.readOnlyNrka = this.selected.erpRoles.readOnlyNrkg
        = this.selected.erpRoles.readOnlyProducts = this.selected.erpRoles.readOnlyMaterials = false;
    }
  }

  offersChanged(offers: boolean) {
    if (offers) {
      this.selected.erpRoles.products = true;
    }
    this.selected.erpRoles.offers = offers ? 1 : 0;
  }
}
